module.exports = __webpack_public_path__ + "img/laowupaiqian.2f84bb8c.png";